import(/* webpackMode: "eager" */ "/codebuild/output/src1757550474/src/www-site-web/src/app/[lang]/error.tsx");
